import { ETeamMembersState } from "@/modules/team-management/services/store/team-members/team-members.types";
import { teamMembersModule } from "@/modules/team-management/services/store/team-members/team-members.module";

// Modules to register on the Vuex instance
export const modules = {
  [ETeamMembersState.NAMESPACE]: teamMembersModule,
};
